import { CoreConfig } from './CoreConfig';
import { LIB_VERSION } from '../Version';
import { Application } from './Application';
import { IInitApplicationUseCaseType } from './Domain/UseCases/Application/InitApplicationUseCase/IInitApplicationUseCase';
import { CoreProviderFactory } from './CoreProviderFactory';
Application.providers.set(CoreConfig.provider, {
    factory: () => CoreProviderFactory.create(),
    provider: CoreProviderFactory.create()
});
export const CoreModuleFactory = {
    version: LIB_VERSION,
    create(initParams = {}) {
        Application.update(CoreConfig.moduleName, initParams);
        return Application.providers.loadProvider(CoreConfig.provider);
    }
};
export function initReactApplication(initParams = {}) {
    var _a;
    CoreModuleFactory.create(initParams);
    const provider = (_a = Application.providers.get(CoreConfig.provider)) === null || _a === void 0 ? void 0 : _a.provider;
    if (!provider) {
        return Promise.reject(new Error('Core provider is not registered!'));
    }
    return provider.resolve(IInitApplicationUseCaseType)
        .then(useCase => {
        if (!useCase) {
            return Promise.reject(new Error('Init application use case is not found!'));
        }
        return useCase.execute();
    });
}
